module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Taxiing on the ramp at Novosibirsk in southwestern Siberia, Dashik Flight R7 looked like any other tired Russian jet, weighed down by creditors as well as metal fatigue. Anyone glancing at the exterior of the Ilyushin IL-62 as it bumped toward the runway would easily see that the craft was preparing for its last miles. Aeroflot’s faded paint scheme was still visible on the fuselage though the Russian airline hadn’t operated or even owned the craft for nearly a decade and a half. Shiny metal patches lined the lower wing and fuselage where repairs had been made, and there was a rather conspicuous dent next to the forward door on the right side of the plane. Though converted from passenger to cargo service aeons ago, the plane retained its windows. About half had been painted over halfheartedly; the rest were still clear, though a third of these were blocked by shades, most stuck at odd angles. A close inspection of the four Soloviev D-30K engines below the tail would reveal that they had recently been serviced, but that was clearly an anomaly—the tires on the landing gear had less tread than the average Hot Wheels car.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("According to the details of the flight records filed with the authorities, the onetime airliner was now used primarily to fly parts west of the Ural Mountains. Tonight its manifest showed three crates of oil pumps and related machinery were aboard. They were bound for Vokuta, from which they ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("would be trucked to their final destination, about thirty miles farther east. The crates had been duly inspected, though as usual the inspector had been somewhat more interested in the unofficial (though definitely mandatory) fee for his services than in the crates themselves.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perhaps because of the weather, the inspection had been conducted in the airport cargo handling area before the plane was loaded. Had the inspector ventured into the aircraft itself, he would have found nothing unusual, except for the sophisticated glass wall of flight instruments lining the cockpit. Such improvements were out of place in an aged and obviously worthless craft, though since the inspector knew little about airplanes it was doubtful he would have drawn any such conclusion. Nor would he have been surprised to find that the door on the compartment aft of the flight deck could not be opened. Such doors and compartments were the rule rather than the exception. On discovering the door, his next step would have been to elicit an additional fee for overlooking it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dashik R7’s locked compartment held neither "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mafiya")]), _vm._v(" cash nor drugs, as the inspector would have guessed. Instead, a small fold-down seat and a long metal counter dominated the space; on the countertop were two large video screens, stacked one atop the other. They looked as if they had been taken from a home theater setup, but in fact the thick bundle of fiber-optic cables extruding from the sides was attached to a computer system whose parallel processing CPUs and flash-SRAM memory lined the full floor of the cargo bay. This computer system had no keyboard, accepting its commands through a special headset that could be used by only one person in the world. The beaked band at the top of the headset included sensors that analyzed both the operator’s voice and retinas; it would only communicate with the computer if they matched the configuration hard-wired into the computer’s circuits.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("By no coincidence at all, the man the headset had been designed for sat in the locked compartment, waiting patiently as Dashik R7 gunned its finely tuned and subtly modified ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Solovievs a touch more aggressively than a casual observer might have expected. For the first thirty yards down the runway it might properly be described as lumbering; from that point on, however, it moved with the efficiency of a well-tuned military jet, leaping rather than faltering into the sky.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stephan Moyshik—more accurately known as Stephen Martin, though only to his ultimate employer—breathed slowly and deeply as the plane took off, willing his consciousness to remain locked in the Zen meditation exercise he had practiced for months. The Dramamine he had taken a half hour ago calmed his stomach, but there was no cure for the claustrophobic feel of the small compartment, nor the sensation of helplessness that crept across his shoulders as the Ilyushin climbed. Martin knew that his anxiety would pass; it always did. But knowing such a thing could not completely erase his fear. When Martin had come to Russia at the start of the Wave Three missions three months before, he felt mildly agitated at takeoff and landing. Now his heart pounded and sweat poured from every part of his skin, his breath the erratic cacophony of a dozen pneumatic drills firing at once. Ironically, he was himself a pilot, though not qualified on multiengined craft.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Martin spent the first twenty-seven minutes after takeoff tonight in high panic. Two large blades, one black, one white, twisted in the middle of his chest, their dagger points entwined around his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Twenty-eight minutes after takeoff, a low tone sounded in his headset. Martin took a long breath, then reached his fingers to adjust the mouthpiece. His fingers trembled so badly that he had a great deal of difficulty setting it in place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet once it was there, the panic ebbed. “Readying startup,” he told the pilot over the interphone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Roger that. We are fifteen minutes from Alpha.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Martin looked up at the blank screens for a moment, then reached to the counter and placed his hand on a highly polished rectangle at the right. The sensors below read his fingerprints; red dots appeared in the middle of the screens.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Command: System activate. Diagnostics One,” said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The computer did not acknowledge directly. Instead, a pink light flickered at the center of both screens, and then their dark surfaces flared with a barrage of color. A mosaic of different shades—actually a diagnostic screen for the video components—materialized in mirror images, one atop the other. Martin settled his hands into his lap, thumbs together over his thighs. The computer spent the next five minutes testing itself and the discrete-burst communication system it used to communicate with the outside world. When that was done, it turned its diagnostics to the intricate grid embedded in its wings, fine-tuning the induction device so that it could pick up the presence of a discarded compass magnet at 50,000 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The computer had to get considerably closer to the ground to pick up the magnetic patterns on a spinning disk drive—15,000 feet, though they would fly at 12,000 to give themselves a margin for error.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Alpha in zero nine,” said the pilot just as the tests were complete.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” said Martin, his eyes focused on the pattern of colored dots on the top screen. The computer could easily filter very strong magnetic fields as Dashik R7 passed over them; the great difficulty was dealing with subtle sources. For some reason, discarded telephones presented the greatest difficulty; all of Martin’s tweaks—delivered as voice commands and prods on the touch-sensitive screens—barely screened 50 percent of the devices from their net. Given that they had a limited capacity to transmit the data to the collection satellites above, and the fact that they had to fly without arousing suspicion, every mistaken capture was costly. On their last flight, Martin had recorded the data of a fax machine apparently belonging to a dentist; he suspected that colleagues would now refer to him as “the Periodontist” in derision.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Martin pointed to a magenta cluster at the right-hand side of the screen and made a circular motion with his index ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("finger. The cluster zoomed into a white-lined box with a black legend at the edge—a twenty-megabyte hard drive, probably belonging to a laptop. Had they been transmitting, a tap in the middle of the cluster would have uploaded all of the magnetic patterns into the capture satellite above; from there it would have been beamed back to the U.S. for analysis. Within twelve or fifteen hours, depending on the shift, the contents of the drive would be available for detailed inspection.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Satisfied that he had the gear tuned as well as he could, Martin ordered the computer to display a sitrep map on the lower screen. The map, using GPS input and an extensive map library updated by daily satellite input, showed Dashik R7’s position on a simulated 3-D image as it approached the Iachin commercial complex, the small R and R facility west of Kargasok operated by Voyska PVO that was tonight’s target. Martin was neither privy to the intercept nor briefed on the precise significance of his target, but he would have been dull indeed not to know what the high-tech NSA sniffer was looking for. The Russians had lately been trying to perfect their long-range laser technology, creating a weapon that could conceivably replace conventional antiair and perhaps antisatellite missiles. Two complexes containing laser directors—the units that actually emitted the high-energy beam—either were being constructed or had been constructed east of the Urals. Not only had Martin seen them on the satellite images included in the flight briefs, but also their instructions included strict language to avoid those areas. The facility they were targeting was located about halfway between them; he assumed that the computers were connected by dedicated fiber-optic cable to the facilities and contained information about the tests. (Had the connection been more conventional, it could have been penetrated by easier means.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sitrep showed Dashik R7 over a wasteland about two minutes from the stretched elliptical cone where information could be swept into the net. Martin raised his head from the screen, a wave of relief flooding over him. It was downhill from here, just a matter of punching buttons.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shit,” said the copilot over the interphone. “Company.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bogey at twenty thousand feet, coming right over us,” explained the pilot, his voice considerably calmer than the copilot’s. “MiG-29 radar active. No identifier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Martin ignored them, concentrating on the top video screen. He pointed to a bright red cluster in the left-hand quadrant. This belonged to a rather large disk array a few miles from their target area. It had the sort of profile he’d seen from units used by banks for financial records, but since their briefing hadn’t identified any large computer systems here—and the sitrep showed they were still over a largely unpopulated area—Martin decided it was worth starting the show a little early.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Command: Transmit. Command: Configuration Normal One.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The computer gave him a low tone to confirm that it had complied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The copilot drowned it out. “That son of a bitch is targeting us!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Keep your diaper clean,” said the pilot. “He’s only going to hit us for a bribe. He’s alone. He’s obviously a pirate. Hail him. Tell him we’ll agree to terms. His squadron probably ran out of whore money—or jet fuel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing on the radio. He thinks we don’t know he’s here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hail him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Martin once more tried to ignore the conversation. Air pirates were rarely encountered by Dashik since they freely paid the protection fees in advance, but there were always new groups muscling in. Legitimate PVO units obtained quite a bit of “supplemental funding” through their Air Security fees; occasional freelancers got in the act for a few weeks or as long as they could get away with it. The agreement to make a certain credit card payment to a specific account upon landing generally precluded being diverted; if that didn’t work, naming a specific PVO general as their protector inevitably got the pirate to break off. Russia’s chaos had grown considerably over the past few months; the coun")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("try’s economy, never strong, was once more teetering. Part of the problem had to do with an increase in military expenditures to develop new weapons and deal with insurgencies in the southern parts of the country, but Martin thought the country would have been far better off putting the money into things such as housing or even subsidizing agriculture.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not that anyone would have been interested in his opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The red clusters on the video screen pulsated as their contents were transmitted. A white dialogue box opened to their right, the computer sniffing a significant sequence. A run of hexadecimals shot across the screen; Martin tapped them to stop the flow of numbers, then pointed below the box.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Command: Open Delphic Fox translator. Access: Compare.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The computers took the intercepted sequence and examined them for signifiers that were used in the current Russian military telemetry and data storage. As smart as they were, Dashik’s onboard computers did not have the capacity—or time—to translate the information, let alone hunt for cipher keys or do anything to “break” an encryption. But that wasn’t the point. By identifying the way the information was organized, the system helped operators decide what to capture. Its significance was determined elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OX")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LUE")]), _vm._v(", V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ARIATION")]), _vm._v(" 13, declared the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Martin had no idea what Fox Blue, Variation 13, was, only that it was on his list to capture. He directed the system to concentrate all of its energy on tapping the source rather than continuing to scan for others. He debated asking the satellite image library for a close-up of the target building, which looked like a small shed on the bottom screen. But the library wasn’t kept onboard, and requesting the information from SpyNet and having it beamed back down would narrow the transmit flow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An overflow error appeared—clearly this was a very large storage system; the plane’s equipment couldn’t keep up with the data it was stealing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“Slow to minimum speed,” Martin told the pilot. “We ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("may have to circle back on this one. This is something interesting.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Impossible. Hold on—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the next second, Martin felt his stomach leave his body. The aircraft plummeted, twisting in the air on its left wing. As it slammed back in the opposite direction, the seat belt nearly severed his body. The computer sounded a high tone that meant it was losing its ability to reap magnetic signatures; the signal grew sharp and then was replaced by a hum—they were no longer collecting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The copilot shouted so loudly Martin could hear him through the bulkhead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Missiles! Missiles! Jesus!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next thing Martin heard was a deep, low rattle that traveled through the floor and up into his seat. He felt cold grip his shoulders but had enough presence of mind to issue a command to the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Command: Contingency D. Authorization Alpha Moyshik Moyshik. Destruct. Cleo—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cleo was not part of command sequence; it was the name of his six-year-old daughter, whom he’d lost to his wife after their divorce five years ago. It was also the last word he spoke before a second missile struck Dashik R7—aka NSA Wave Three Magnetic Data Gatherer Asset 1—and ignited the fuel tank in the right wing. In the next second, the aircraft flared into a bright meteor in the dark Siberian night.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-860bf548","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954730_ch01.vue
// module id = 72
// module chunks = 0